<template>
    <v-sheet>
        <step-questions-list v-model="form.questions" v-bind="{ _recruitment: value._recruitment }" @input="emit" />

        <div class="v-btn-group flex-wrap">
            <v-btn v-bind="{ loading }" outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="$emit('prev')"><span class="grey-6--text">이전으로</span></v-btn>
            <v-btn v-bind="{ loading }" outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="save()"><span class="grey-6--text">임시저장</span></v-btn>
            <v-btn v-bind="{ loading }" color="primary" class="min-w-140px min-w-lg-160px" @click="save(COMPLETED.value)"><span>저장 후 다음으로</span></v-btn>
        </div>
    </v-sheet>
</template>

<script>
import api from "@/api";
import { APPLICATION_STATES, APPLICATION_WRITIG_STEPS, initApplication } from "@/assets/variables";
import StepQuestionsList from "./step-questions-list.vue";

const state = APPLICATION_STATES.ON_WRITING.value;
const { QUESTIONS, COMPLETED } = APPLICATION_WRITIG_STEPS;

export default {
    components: {
        StepQuestionsList,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // form
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        form: initApplication(),

        COMPLETED,
    }),
    computed: {
        isCreate() {
            return !this.value?._id;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initApplication(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        validation() {
            for (let [index, item] of this.form.questions.entries()) {
                if (!item.response) {
                    alert(`${index + 1}번째 질문에 답변해주세요.\n질문: "${item.question.subject}"`);
                    return false;
                }
            }
            return true;
        },
        async save(writingStep = QUESTIONS.value) {
            if (!this.validation()) return;

            if (this.loading) return;
            else this.$emit("setLoading", true);

            try {
                let { ...form } = this.form;
                form.state = state;
                form.writingStep = writingStep;

                let { post, put } = api.v1.recruitments.application;
                const { application } = await (this.isCreate ? post : put)(form);

                this.$emit("input", initApplication(application));
                alert("저장되었습니다");
                this.$emit("setLoading", false);
                this.$nextTick(() => {
                    if (writingStep != QUESTIONS.value) this.$emit("next");
                });
            } finally {
                this.$emit("setLoading", false);
            }
        },
    },
};
</script>
